// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3t2Ij","alertIcon":"ConfirmModal_alertIcon__34MbC"};